/**
 * @Description 地铁
 */
import { FC, useEffect, useRef, useState } from 'react';
import { Switch } from 'antd';
import styles from './index.module.less';
import { getSubwayStation, getSubwaySubwayNames } from '@/common/api/siteselectionmap';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import useUpdateEffect from '@/common/hook/updateEffect/useUpdateEffect';
// import IconFont from '@/common/components/IconFont';
import ReactDOM from 'react-dom';
import { v4 } from 'uuid';
import { useMethods } from '@lhb/hook';
import { isArray, isNotEmptyAny } from '@lhb/func';
const LayerSubway: FC<any> = ({
  mapIns,
  setActive,
  isOpenSubway,
  setIsOpenSubway,
  cityProvinceInfo,
}) => {
  const cityId = cityProvinceInfo?.id;
  const districtIds = cityProvinceInfo?.districtIds;
  const hoverMarker = useRef<any>(null);
  const markerListRef = useRef<any>([]);
  const [subwayList, setSubwayList] = useState<any>([]);
  const [subwayNameLists, setSubwayNameLists] = useState<any>([]);
  const [subwayLinePolyline, setSubwayLinePolyline] = useState<any>([]); // 地铁线
  const [subwayStartStopText, setSubwayStartStopText] = useState<any>([]); // 起止站点文本标记

  const methods = useMethods({
    async getSubwayNames() { // 获取城市下的所有地铁名称
      if (!cityId) return;
      await getSubwaySubwayNames({ cityId }, false).then(result => {
        result.forEach(item => {
          if (item?.lineName?.includes('(')) {
            item.lineName = item.lineName?.split('(')[0];
          }
          return item;
        });
        setSubwayNameLists(result);
      });
    },
    drawSubwayLine() { // 绘制地图线路

      if (!cityProvinceInfo || !cityProvinceInfo?.name) return;

      /* 绘制路线 */
      const drawLine = (BusArr, color) => {
        const polyline = new window.AMap.Polyline({
          map: mapIns,
          path: BusArr,
          strokeColor: `#${color}`, // 线颜色
          strokeOpacity: 1, // 线透明度
          isOutline: true,
          outlineColor: 'white',
          strokeWeight: 5 // 线宽
        });

        subwayLinePolyline.push(polyline);
        setSubwayLinePolyline(subwayLinePolyline);
      };

      subwayNameLists?.map(item => {
        const lineArr = item.polylineList;
        const lineNum = item.polylineList.length;

        if (lineNum === 0) {
          console.log(lineNum);
        } else {
          const path = lineArr.map((item) => [item.lng, item.lat]);
          drawLine(path, item.uicolor);

          const originStop = lineArr.filter((item) => item.originating === 1);

          methods.drawStartStopStation(item.simpleLineName, originStop, item.uicolor,);
        }
      });

    },
    /**
     * 渲染起止站点
     * @param lineName 线路名称
     * @param viaStops 站点信息
     * @param color 颜色
     */
    drawStartStopStation(lineName, viaStops, color) {
      // lineName = lineName.replace(/号线/, '').replace(/地铁/, '').replace(/支线/, '').replace(/轨道交通/, '').replace(/佛山/, '').replace(/大兴线/, '').replace(/南海有轨电车/, '').trim();
      // console.log(`lineName = `, lineName);

      if (isArray(viaStops) && viaStops[0]?.lng) { // 如果viaStops 有值
        const text = new window.AMap.Text({
          text: lineName, // 标记显示的文本内容
          anchor: 'center', // 设置文本标记锚点位置
          draggable: false, // 是否可拖拽
          style: {
          // 设置文本样式，Object 同 css 样式表
            'padding': '5px',
            'border-radius': '4px',
            'background-color': `#${color}`,
            'border-width': 0,
            'min-width': '24px',
            'text-align': 'center',
            'font-size': '12px',
            'color': '#fff',
          },
          position: new window.AMap.LngLat(viaStops[0].lng, viaStops[0].lat), // 点标记在地图上显示的位置
        });
        text.setMap(mapIns); // 将文本标记设置到地图上
        const text2 = new window.AMap.Text({
          text: lineName, // 标记显示的文本内容
          anchor: 'center', // 设置文本标记锚点位置
          draggable: false, // 是否可拖拽
          style: {
          // 设置文本样式，Object 同 css 样式表
            'padding': '5px',
            'border-radius': '4px',
            'background-color': `#${color}`,
            'border-width': 0,
            'min-width': '24px',
            'text-align': 'center',
            'font-size': '12px',
            'color': '#fff',
          },
          position: new window.AMap.LngLat(viaStops[viaStops.length - 1].lng, viaStops[viaStops.length - 1].lat), // 点标记在地图上显示的位置
        });
        text2.setMap(mapIns); // 将文本标记设置到地图上

        subwayStartStopText.push(text);
        subwayStartStopText.push(text2);
        setSubwayStartStopText(subwayStartStopText);
      }
    },
    async getSubwayData() {
      if (!cityId || !isOpenSubway) {
        setSubwayList([]);
        return;
      }

      // 防止数据没请求完就开始画地铁线路
      await methods.getSubwayNames(); // 获取城市下的所有地铁名称

      getSubwayStation({
        cityId,
        size: 500// 目前全国北京最多,489个，所以不分页查询了
      }).then((val) => {
        let res;
        if (districtIds?.length) {
          // 勾选了行政区
          res = val.reduce((acc, item) => {
            if (districtIds?.includes(item?.districtId)) {
              acc.push(item);
            }
            return acc;
          }, []);
        } else {
          // 未勾选行政区
          res = val;
        }

        setSubwayList(res);
        if (!res?.length) {
          V2Message.error('当前城市无地铁站');
        }
      });
    }
  });

  useEffect(() => {
    methods.getSubwayData();
  }, [cityId, districtIds, isOpenSubway]);

  useUpdateEffect(() => {
    if (!mapIns) return;
    markerListRef.current?.map((marker) => {
      mapIns.remove(marker);
      mapIns.remove(subwayLinePolyline);
      mapIns.remove(subwayStartStopText);
    });
    markerListRef.current = [];
    subwayList.map((item) => {
      const marker = new window.AMap.Marker({
        position: [item?.lng, item.lat],
        anchor: 'center',
      });
      marker.on('mouseover', () => {
        if (hoverMarker.current) return;
        hoverMarker.current = new window.AMap.Marker({
          position: [item?.lng, item.lat],
          anchor: 'center',
          offset: [0, 52],
        });
        mapIns.add(hoverMarker.current);

        const uid = v4();
        hoverMarker.current.setContent(`<div id="${uid}"></div>`);
        ReactDOM.render(<div className={styles.stationDetail}>
          <div className={styles.triangle}></div>
          <div>
            <span className='c-999 mr-4'>线路</span>
            <span>{item.lienName}</span>
          </div>
          <div className='mt-8'>
            <span className='c-999 mr-4'>站点</span>
            <span>{item.stationName}</span>
          </div>
        </div>, document.getElementById(uid));

      });
      marker.on('mouseout', () => {
        mapIns.remove(hoverMarker.current);
        hoverMarker.current = null;
      });
      mapIns.add(marker);
      markerListRef.current.push(marker);
    });
    // 必须先添加了才能用React.render
    markerListRef.current.map((marker) => {
      const uid = v4();
      marker.setContent(`<div id="${uid}"></div>`);
      ReactDOM.render(<div className={styles.station}>
        {/* <IconFont iconHref='icona-ic_xuanzhiditie' className={styles.subwayIcon}/> */}
      </div>, document.getElementById(uid));
    });

    isNotEmptyAny(subwayList) && methods.drawSubwayLine(); // 绘制地图线路

  }, [subwayList]);

  return (
    <div
      onMouseEnter={() => setActive('')}
      className={styles.card}
    >
      <span className='pr-16 c-333 bold'>地铁线路</span>
      <Switch
        className={styles.switch}
        size='small'
        checked={isOpenSubway}
        onChange={() => {
          setIsOpenSubway(state => !state);
        }}
      />
    </div>
  );
};

export default LayerSubway;
